import { PEChildrenCardActions, PEChildrenCardGetters, PEChildrenCardMutations } from './pe-children-card'
import {
  PEChildrenIncomeRowActions, PEChildrenIncomeRowGetters, PEChildrenIncomeRowMutations,
} from './pe-children-income-row'
import { PEMarriagesCardActions, PEMarriagesCardGetters, PEMarriagesCardMutations } from './pe-marriages-card'
import {
  PEMarriagesIncomeRowActions, PEMarriagesIncomeRowGetters, PEMarriagesIncomeRowMutations,
} from './pe-marriages-income-row'
import { PEParentsCardActions, PEParentsCardGetters, PEParentsCardMutations } from './pe-parents-card'
import {
  PEParentsIncomeRowActions, PEParentsIncomeRowGetters, PEParentsIncomeRowMutations,
} from './pe-parents-income-row'
import { PESiblingsCardActions, PESiblingsCardGetters, PESiblingsCardMutations } from './pe-siblings-card'
import {
  PESiblingsIncomeRowActions, PESiblingsIncomeRowGetters, PESiblingsIncomeRowMutations,
} from './pe-siblings-income-row'
import { peFamilySectionActions, peFamilySectionGetters, peFamilySectionMutations } from './pe-family-section'

export const FamiliesSectionActions = {
  ...PEChildrenCardActions,
  ...PEChildrenIncomeRowActions,
  ...PEMarriagesCardActions,
  ...PEMarriagesIncomeRowActions,
  ...PEParentsCardActions,
  ...PEParentsIncomeRowActions,
  ...PESiblingsCardActions,
  ...PESiblingsIncomeRowActions,
  ...peFamilySectionActions,
}

export const FamiliesSectionGetters = {
  ...PEChildrenCardGetters,
  ...PEChildrenIncomeRowGetters,
  ...PEMarriagesCardGetters,
  ...PEMarriagesIncomeRowGetters,
  ...PEParentsCardGetters,
  ...PEParentsIncomeRowGetters,
  ...PESiblingsCardGetters,
  ...PESiblingsIncomeRowGetters,
  ...peFamilySectionGetters,
}

export const FamiliesSectionMutations = {
  ...PEChildrenCardMutations,
  ...PEChildrenIncomeRowMutations,
  ...PEMarriagesCardMutations,
  ...PEMarriagesIncomeRowMutations,
  ...PEParentsCardMutations,
  ...PEParentsIncomeRowMutations,
  ...PESiblingsCardMutations,
  ...PESiblingsIncomeRowMutations,
  ...peFamilySectionMutations,
}
